import OfferLabels from 'components/Common/Labels/OfferLabels'
import OfferBadgeLabel from 'components/Common/OfferBadgeLabel/OfferBadgeLabel'
import ContentTagLabels from 'components/Content/ContentTagLabels'
import KidsFlyFreeLabel from 'components/Common/Labels/KidsFlyFreeLabel'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import OfferTilePricingUrgencyTags from 'components/OfferList/OfferListTiles/Support/OfferTilePricingUrgencyTags'
import { useSearchPrices } from 'hooks/Search/useSearchPrices'
import { useOfferInclusions } from 'hooks/useOfferInclusions'
import React, { useMemo } from 'react'
import { isFlashHotelOffer } from 'lib/offer/offerTypes'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCharterBundleRoute } from 'selectors/offerPage/initialOfferPageStateSelectors'
import useKidsFlyFree from 'hooks/CharterFlights/useKidsFlyFree'
import { useMaldivesDirectBundleContext } from 'components/MaldivesDirect/MaldivesDirectSearchPage/MaldivesDirectBundleContext'

interface Props {
  bestPackage?: App.HotelPackage
  filters?: App.OfferListFilters
  offer: App.HotelOffer | App.HotelOfferSummary
  showUrgencyTags?: boolean
}

function HotelSearchTileLabels({
  bestPackage,
  filters,
  offer,
  showUrgencyTags = true,
}: Props) {
  const charterBundleRoute = useAppSelector(state => getCharterBundleRoute(state, offer))
  const { fareClass } = useMaldivesDirectBundleContext()
  const { shouldShowKidsFlyFreeForOffer } = useKidsFlyFree({ charterBundleRoute, fareClass })
  const { totalPrice, totalMemberPrice, showMemberPrice } = useSearchPrices({
    offer,
    pkg: bestPackage,
    filters,
    useRealSearchPrices: true,
  })
  const saveAmount = totalPrice - (totalMemberPrice || 0)

  const { luxPlusInclusions } = useOfferInclusions(
    bestPackage,
    {
      checkIn: filters?.checkIn,
      checkOut: filters?.checkOut,
    },
  )

  const searchTileLuxPlusInclusions = useMemo<Array<App.PackageInclusion>>(() => {
    if (offer.luxPlusTileInclusions?.length) {
      return offer.luxPlusTileInclusions
    }
    return luxPlusInclusions
  }, [luxPlusInclusions, offer.luxPlusTileInclusions])
  const showLuxPlusInclusions = !!searchTileLuxPlusInclusions.length
  const utmSource = useAppSelector(state => state.utm.source)
  const noGoogleAffiliations = utmSource !== 'google'
  const showMemberInclusionLabel = !!offer.luxPlus.hasMemberInclusions && !showLuxPlusInclusions && (!noGoogleAffiliations || isFlashHotelOffer(offer))
  return <LabelGroup>
    {shouldShowKidsFlyFreeForOffer(offer, filters?.checkIn) && <KidsFlyFreeLabel />}
    <ContentTagLabels offerId={offer.id} page="search" />
    <OfferLabels
      offer={offer}
      saveAmount={showMemberPrice ? saveAmount : undefined}
      showMemberInclusionLabels={showMemberInclusionLabel}
      luxPlusInclusions={luxPlusInclusions}
      leadWithLuxPlusPrice
    />
    {showUrgencyTags && <OfferTilePricingUrgencyTags offer={offer} filters={filters} />}
    {offer.badge && <OfferBadgeLabel badge={offer.badge} />}
  </LabelGroup>
}

export default HotelSearchTileLabels
